// ST (session total strokes): running total of rate ÷ 60 × seconds since the
// last update, added only while a rate is shown and the session is not paused.
// The fraction is kept between updates; ST = whole number (rounded down).
export const createStrokeCounter = () => {
  let total = 0;
  let lastT = null;
  return {
    update(t, rateSpm, paused) {
      const dt = lastT == null ? 0 : Math.max(0, (t - lastT) / 1000);
      lastT = t;
      if (rateSpm > 0 && !paused) total += (rateSpm / 60) * dt;
      return Math.floor(total + 1e-9); // tolerance for float sums (120 x 0.2 = 23.999…)
    },
    reset() { total = 0; lastT = null; },
  };
};
